
import { computed, onMounted, onUnmounted, ref, defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useToast } from 'primevue/usetoast';
import { dragscrollNext } from 'vue-dragscroll';
import Toolbar from 'primevue/toolbar';
import Button from 'primevue/button';
import 'vue-advanced-cropper/dist/style.css';

import { Icon, Loader } from '../../../components/ui';
import substrateImg from '../../../assets/img/substrate.png';
import { useStores } from '@/store/Stores';

export default defineComponent({
  components: {
    Toolbar,
    Button,
    Icon,
    Loader
  },
  directives: {
    dragscroll: dragscrollNext
  },
  props: {
    total: Number,
    selected: Number,
    item: Object
  },
  emits: ['changeItem', 'closeModal'],
  methods: {
    removeExtraPhoto() {
      if (confirm('Are you sure you want to delete this photo?')) {
        const body = { car: this.$route.params.id, photos: [this.item.id] };

        this.carStore.removeExtraPhoto(body, this.toast, this.t);
        this.$emit('closeModal');
      }
    }
  },
  setup(props, { emit }) {
    const { carStore, carStoreState } = useStores();

    const route = useRoute();
    const toast = useToast();
    const { t } = useI18n();
    const imagePreviev = ref();
    const base64Image = ref();
    const current = ref(props.selected);

    console.log(props);

    const data = computed(() => carStoreState.data);
    const photoUploading = computed(() => carStoreState.photoUploading);
    const currentItem = computed(() => props.item);

    function handlingArrowKey(e) {
      switch (e.key) {
        case 'ArrowLeft':
          e.preventDefault();
          callback(-1);
          break;
        case 'ArrowRight':
          e.preventDefault();
          callback(1);
          break;
      }
    }

    function callback(mod) {
      const summ = current.value + mod;
      if (summ >= 0 && summ < props.total) {
        current.value = summ;
        emit('changeItem', current.value);
      }
    }

    function uploadFile(event) {
      const file = event.target.files[0];
      var reader = new FileReader();
      reader.onloadend = function () {
        currentItem.value.base_64_image = reader.result;
      };
      reader.readAsDataURL(file);
      const body = {
        car: route.params.id,
        photo: file,
        angle: props.item.id
      };

      carStore.uploadPhoto(body, toast, t);
    }
    function processing() {
      const body = { car: route.params.id, photo: props.item.photo_id };

      carStore.processPhoto(body, toast, t);
    }

    function handlingImage({ canvas }) {
      base64Image.value = canvas.toDataURL();
    }

    onMounted(() => {
      document.addEventListener('keydown', handlingArrowKey, true);
    });
    onUnmounted(() => {
      document.removeEventListener('keypress', handlingArrowKey, true);
    });

    return {
      carStore,
      toast,
      t,
      current,
      callback,
      data,
      handlingImage,
      processing,
      imagePreviev,
      uploadFile,
      base64Image,
      currentItem,
      photoUploading,
      substrateImg
    };
  }
});
